export const JsonHelper = {
  methods: {
    isJsonObject (data) {
      let result = false
      try {
        const parsed = JSON.parse(data)
        result = parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed)
      } finally {
        return result // eslint-disable-line no-unsafe-finally
      }
    },
    processNestedObject (key, val, depth, isBaseArray) {
      const label = isBaseArray ? (Number.parseInt(key) + 1) : key
      const nested = this.getParsedJsonRows(JSON.stringify({...val}), depth + 1)
      return [{key: label, value: null, depth}, ...nested]
    },
    processArrayValue (key, arr, depth) {
      if (arr.length === 0) {
        return [{key, value: 'Ni podatka', depth}]
      }
      if (typeof arr[0] === 'object' && arr[0] !== null) {
        const nested = this.getParsedJsonRows(JSON.stringify([...arr]), depth + 1)
        return [{key, value: null, depth}, ...nested]
      }
      return [{key, value: arr.join(', '), depth}]
    },
    processEntry (key, val, depth, isBaseArray) {
      if (val !== null && typeof val === 'object' && !Array.isArray(val)) {
        return this.processNestedObject(key, val, depth, isBaseArray)
      }
      if (Array.isArray(val)) {
        return this.processArrayValue(key, val, depth)
      }
      if (!['access_token'].includes(key)) {
        return [{key, value: val === null ? 'Ni podatka' : val, depth}]
      }
      return []
    },
    getParsedJsonRows (json, depth) {
      if (depth === 10) return []
      const obj = JSON.parse(json)
      if (typeof obj !== 'object') return []
      const isBaseArray = Array.isArray(obj)
      return Object.keys(obj).flatMap(key => this.processEntry(key, obj[key], depth, isBaseArray))
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/JsonHelper.js